import React from 'react';

export const CommentDisclaimerModal = {
  title: 'Comments',
  body: (
    <div>
      <p>The information presented in this database, including the Comments section, are not necessarily the view of NOAA/NCEI, but were cited from the references.</p>
    </div>
  ),
};
